import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ServicoGuardaSincronizacaoRegistrador {
  readonly intervaloMinimoRepeticaoMs = 30_000;

  deveProtegerLeituraAposSincronizacao(sincronizados: number) {
    return sincronizados > 0;
  }

  mensagemAguardandoSincronizacao() {
    return 'Sincronizando registros offline. Aguarde.';
  }

  mensagemSincronizacaoConcluida() {
    return 'Registros offline sincronizados. Aguarde a proxima leitura.';
  }

  mensagemPontoJaRegistrado() {
    return 'Seu ponto foi confirmado. Aguarde o periodo seguinte para leitura.';
  }

  deveRepetirAvisoPontoJaRegistrado(params: {
    aguardandoSaidaDoRosto: boolean;
    funcionarioId: string;
    validoAte: number;
    rostoDetectado: boolean;
    agora?: number;
  }) {
    const agora = params.agora ?? Date.now();
    return params.aguardandoSaidaDoRosto
      && Boolean(params.funcionarioId)
      && agora <= params.validoAte
      && params.rostoDetectado;
  }

  ehMesmoServidorRecemRegistrado(
    descritorAtual: number[],
    descritorAnterior: number[],
    validoAte: number,
    agora = Date.now()
  ) {
    if (!descritorAtual.length || !descritorAnterior.length || agora > validoAte) {
      return false;
    }
    if (descritorAtual.length !== descritorAnterior.length) {
      return false;
    }
    return this.distanciaEuclidiana(descritorAtual, descritorAnterior) <= 0.55;
  }

  private distanciaEuclidiana(atual: number[], anterior: number[]) {
    return Math.sqrt(atual.reduce((total, valor, indice) => {
      const diferenca = valor - anterior[indice];
      return total + diferenca * diferenca;
    }, 0));
  }
}
